/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import { EXP_CANADA_ADDRESS } from '@tenants/definitions/shared/addresses';
import { LOCALE_EXP_REALTY_CA_PATHS } from 'types/locales';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_EXPLOREEXP_LABEL,
          link: '/explore-exp',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_FINDAGENT_LABEL,
          link: '/agents-search',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_JOINEXP_LABEL,
          link: 'https://join.exprealty.ca',
          target: '_blank',
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_INVESTORRELATIONS_LABEL,
          link: 'https://expworldholdings.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_COMPANYCAREERS_LABEL,
          link: 'https://expworldholdings.com/careers/',
          target: '_blank',
          isAnchor: true,
        },
      ],
      column2: [
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_EXPLIFE_LABEL,
          link: 'https://life.exprealty.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_ZOOCASA_LABEL,
          link: 'https://zoocasa.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_SUCCESS_LABEL,
          link: 'https://www.success.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_QUEBECLISTINGS_LABEL,
          link: 'https://expquebec.com/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_ACCESSIBILITY_LABEL,
          link: '/accessibility',
          isAnchor: true,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_TERMSANDCONDITIONS_LABEL,
          link: 'https://expworldholdings.com/terms-of-service/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_PRIVACYPOLICY_LABEL,
          link: 'https://expworldholdings.com/privacy-policy/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_COOKIEPOLICY_LABEL,
          link: 'https://expworldholdings.com/cookie-policy/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_TERMSANDCONDITIONSFR_LABEL,
          link: 'https://expworldholdings.com/terms-of-service-fr/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_LEGAL_PRIVACYPOLICYFR_LABEL,
          link: 'https://expworldholdings.com/privacy-policy-fr/',
          target: '_blank',
          isAnchor: true,
        },
        {
          label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_SITEMAP_LABEL,
          link: '/sitemap',
          target: '_blank',
          isAnchor: true,
        },
      ],
      bottom: [
        [
          {
            label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_DISCLOSURES_TRADEMARKS_LABEL,
          },
        ],
        [
          {
            label: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_DISCLOSURES_LISTINGS_LABEL,
          },
        ],
      ],
      joinUsLink: 'https://join.exprealty.ca',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-ca.png',
        alt: LOCALE_EXP_REALTY_CA_PATHS.FOOTER_IMAGE_ALT,
      },
    },
    organization: {
      phoneNumber() {
        return '833-303-0610';
      },
      email() {
        return 'info@exprealty.net';
      },
      address() {
        return EXP_CANADA_ADDRESS;
      },
      twitterUrl: 'https://twitter.com/exprealtycanada',
      facebookUrl: 'https://www.facebook.com/exprealtycanada',
      instagramUrl: 'https://www.instagram.com/expcanada_?igsh=YmtqZzRqZHR1Z2Yw&utm_source=qr',
      linkedinUrl: 'https://www.linkedin.com/showcase/exprealtycanada',
      youtubeUrl: 'https://www.youtube.com/@eXpRealty',
      joinSectionUrl: 'https://join.exprealty.ca',
    },
    showAccessibilityLink: true,
  };
}